import * as yup from "yup";

export const schema = yup.object().shape({
  name: yup.string().required().min(3).max(100),
  icon: yup.string().notRequired(),
  collapse: yup.boolean().required(),
  layout: yup.string().required().min(3).max(50),
  description: yup.string().required().min(3).max(50),
});
